import React from 'react';

import { CutoutLine } from '../CutoutLine';
import classNames from './PageTitleSp.module.scss';

export type Props = {
  main: string;
  sub: string;
};

export const PageTitleSp: React.FC<Props> = ({ main, sub }) => {
  return (
    <div className={classNames['page-title']}>
      <img
        className={classNames['background-image']}
        src="/public/images/Mask_Group_14_dd.png"
      />
      <svg className={classNames.cutout} viewBox="-3853.62 -8968.02 240 56">
        <path
          className={classNames['cutout-path']}
          d="M -3853.620361328125 -8968.01953125 L -3613.620361328125 -8968.01953125 L -3627.666748046875 -8912.01953125 L -3853.620361328125 -8968.01953125 Z"
        />
      </svg>
      <CutoutLine width={360} top={120} left={0} from="left" />
      <div className={classNames['sub-text']}>
        <span>{sub}</span>
      </div>
      <div className={classNames['main-text']}>
        <span>{main}</span>
      </div>
    </div>
  );
};
